import React from 'react';
import cn from 'classnames';
import Sticky from 'react-stickynode';
import { Link, useSearchParams } from 'react-router-dom';

import style from './style.scss';

const MobileHeader = () => {
  const [searchParams] = useSearchParams();
  const key = searchParams.get('key');

  return (
    // Global Header
    <Sticky
      enabled
      innerZ={10}
      activeClass={style.stickyHeaderMobile}
    >
      <header className={style['site-header-mobile']} role="banner">
        <nav className={cn('site-navigation top-bar', style['topbar-mobile'])}>
          <div className="top-bar-left">
            <div className={cn('top-bar-title', style['site-mobile-title'])}>
              <Link to={`${key ? `/fsl/application?key=${key}` : '/fsl/application'}`}>LendingUSA</Link>
            </div>
          </div>
          <div className="top-bar-right">
            <a href="tel:+19496945001" className={cn('phone', style.phone)}><span>Questions?</span> 949-694-5001</a>
          </div>
        </nav>
      </header>
    </Sticky>
    // End Global Header
  );
};

export default MobileHeader;
